import { useCallback, useState } from 'react';

// keys used in localStorage (standardized)
const AUTH_TOKEN_KEY = 'authToken';
const ID_KEY = 'id';
const DISPLAY_KEY = 'display';

// Returns an object: { session, setSession, clearSession }
// session: { authToken, id, display } or null when none present
export default function useSession() {
  const readSessionFromStorage = () => {
    const authToken = localStorage.getItem(AUTH_TOKEN_KEY) || '';
    const id = localStorage.getItem(ID_KEY) || '';
    const display = localStorage.getItem(DISPLAY_KEY) || '';

    if (!authToken && !id && !display) return null;
    return { authToken, id, display };
  };

  const [session, setSessionState] = useState(() => readSessionFromStorage());

  // Keep localStorage and state in sync when setting the session
  const setSession = useCallback(({ authToken, id, display }) => {
    if (authToken !== undefined) {
      localStorage.setItem(AUTH_TOKEN_KEY, authToken);
    }
    if (id !== undefined) {
      localStorage.setItem(ID_KEY, id);
    }
    if (display !== undefined) {
      localStorage.setItem(DISPLAY_KEY, display);
    }
    const newSession = readSessionFromStorage();
    setSessionState(newSession);
    return newSession;
  }, []);

  const clearSession = useCallback(() => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(ID_KEY);
    localStorage.removeItem(DISPLAY_KEY);
    setSessionState(null);
  }, []);

  return { session, setSession, clearSession };
}
